module.exports = __webpack_public_path__ + "img/icon-show.f8db87de.svg";